var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 307,
    viewBox: "0 0 201 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.992 137.755V204.693L192.123 216.479V264.831H193.834V215.874L181.702 204.088V138.51L223.073 98.166V36.8186L251.846 8.86476V-65.4774L238.937 -77.8678V-90.2581H237.382V-77.2633L250.136 -64.873V8.26035L221.363 36.2142V97.5616L179.992 137.755Z",
    fill: "url(#paint0_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9409 -2.31674L82.9409 25.0327L111.869 52.9866V88.6466L193.212 167.673V196.836H194.767V167.068L113.425 88.0422V52.3822L84.6518 24.4283L84.6518 -2.31674H82.9409Z",
    fill: "url(#paint1_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.304 -35.8613L173.304 3.87842L189.634 19.8952V107.232H192.901V18.5353L176.57 2.5185L176.57 -34.6526L197.411 -54.9002V-90.2581H194.145V-56.2601L173.304 -35.8613Z",
    fill: "url(#paint2_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.131 33.4944V96.6549H144.686V34.2499L164.905 14.6066L164.905 -53.8426L177.97 -66.5351V-92.8268H176.414V-67.1395L163.35 -54.447L163.194 13.8511L143.131 33.4944Z",
    fill: "url(#paint3_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.269 -11.2318V16.7221L174.704 76.4073V115.089L145.153 143.799V237.784L128.822 253.801V276.315H132.088V255.01L148.419 238.993L148.419 145.008L177.97 116.449V75.0474L116.38 15.3622V-10.023L129.6 -22.7155L129.6 -92.3735H126.334L126.334 -24.0755L113.269 -11.2318Z",
    fill: "url(#paint4_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.046 24.8815L121.046 128.084L169.727 175.379V230.38L172.993 230.229V174.17L124.156 126.724L124.156 26.0903L147.019 4.02946V-90.2581H143.753V2.66954L121.046 24.8815Z",
    fill: "url(#paint5_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.692 241.562V276.315H111.247V242.166L135.199 218.896L135.199 151.656H133.644L133.644 218.141L109.692 241.562Z",
    fill: "url(#paint6_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2808 -67.5928L43.2808 52.5332L78.4305 86.5311L78.4305 147.879L103.16 171.904V196.231H104.715V171.299L79.9858 147.274L79.9858 85.9267L44.9916 51.9288L44.9916 -66.8373L67.0768 -88.4449V-96H65.5215V-89.0493L43.2808 -67.5928Z",
    fill: "url(#paint7_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.198921 -47.6474L0.198921 53.5909L10.9305 64.017V119.018L84.8072 190.792L84.8072 287.648L70.0319 302.002L71.1206 303.211L86.5181 288.252L86.5181 190.187L12.6413 118.414V63.4126L1.75426 52.9865L1.90976 -47.0429L9.99733 -54.9002V-94.4889H8.28648V-55.5047L0.198921 -47.6474Z",
    fill: "url(#paint8_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6321 133.675L68.6321 216.63H70.3429L70.3429 134.279L101.604 103.908L101.604 -5.03664L137.221 -39.6389V-92.8268H135.51V-40.2433L99.8936 -5.79214L99.8936 103.152L68.6321 133.675Z",
    fill: "url(#paint9_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.212 193.058C191.501 193.058 189.946 194.418 189.946 196.231C189.946 198.044 191.345 199.404 193.212 199.404C195.078 199.404 196.478 198.044 196.478 196.231C196.478 194.418 195.078 193.058 193.212 193.058Z",
    fill: "url(#paint10_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.47 272.689C108.759 272.689 107.204 274.049 107.204 275.862C107.204 277.675 108.603 279.035 110.47 279.035C112.336 279.035 113.736 277.675 113.736 275.862C113.736 274.049 112.336 272.689 110.47 272.689Z",
    fill: "url(#paint11_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.421 148.634C132.555 148.634 131.155 149.994 131.155 151.807C131.155 153.62 132.555 154.98 134.421 154.98C136.288 154.98 137.688 153.62 137.688 151.807C137.688 149.994 136.288 148.634 134.421 148.634Z",
    fill: "url(#paint12_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.249 192.605C102.382 192.605 100.982 193.965 100.982 195.778C100.982 197.591 102.382 198.951 104.249 198.951C106.115 198.951 107.515 197.591 107.515 195.778C107.515 193.965 106.115 192.605 104.249 192.605Z",
    fill: "url(#paint13_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8072 186.863C83.0964 186.863 81.5411 188.223 81.5411 190.036C81.5411 191.849 82.9409 193.209 84.8072 193.209C86.6736 193.209 88.0734 191.849 88.0734 190.036C88.0734 188.223 86.6736 186.863 84.8072 186.863Z",
    fill: "url(#paint14_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.114 50.5689C111.247 50.5689 109.848 51.9288 109.848 53.742C109.848 55.5552 111.247 56.9152 113.114 56.9152C114.98 56.9152 116.38 55.5552 116.38 53.742C116.38 51.9288 114.98 50.5689 113.114 50.5689Z",
    fill: "url(#paint15_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.905 11.2824C163.194 11.2824 161.639 12.6423 161.639 14.4555C161.639 16.2688 163.194 17.6287 164.905 17.6287C166.616 17.6287 168.171 16.2688 168.171 14.4555C168.171 12.6423 166.772 11.2824 164.905 11.2824Z",
    fill: "url(#paint16_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.788 138.057C201.921 138.057 200.522 139.417 200.522 141.23C200.522 143.043 201.921 144.403 203.788 144.403C205.654 144.403 207.054 143.043 207.054 141.23C207.054 139.417 205.654 138.057 203.788 138.057Z",
    fill: "url(#paint17_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.375 93.3307C142.509 93.3307 141.109 94.6907 141.109 96.5039C141.109 98.3171 142.509 99.677 144.375 99.677C146.086 99.677 147.641 98.3171 147.641 96.5039C147.641 94.6907 146.242 93.3307 144.375 93.3307Z",
    fill: "url(#paint18_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3637 82.7536C77.4974 82.7536 76.0976 84.1135 76.0976 85.9267C76.0976 87.74 77.4974 89.0999 79.3637 89.0999C81.0746 89.0999 82.6299 87.74 82.6299 85.9267C82.6299 84.1135 81.2301 82.7536 79.3637 82.7536Z",
    fill: "url(#paint19_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9916 49.0578C43.1252 49.0578 41.7255 50.4177 41.7255 52.2309C41.7255 54.0441 43.1252 55.4041 44.9916 55.4041C46.8579 55.4041 48.2577 54.0441 48.2577 52.2309C48.2577 50.4177 46.8579 49.0578 44.9916 49.0578Z",
    fill: "url(#paint20_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.343 300.189C68.4766 300.189 67.0769 301.549 67.0769 303.362C67.0769 305.176 68.4766 306.536 70.343 306.536C72.2093 306.536 73.6091 305.176 73.6091 303.362C73.6091 301.549 72.2093 300.189 70.343 300.189Z",
    fill: "url(#paint21_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7209 213.003C68.0101 213.003 66.4548 214.363 66.4548 216.177C66.4548 217.99 67.8546 219.35 69.7209 219.35C71.4318 219.35 72.9871 217.99 72.9871 216.177C72.9871 214.363 71.5873 213.003 69.7209 213.003Z",
    fill: "url(#paint22_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6517 -3.37451C82.7853 -3.37451 81.3856 -2.01461 81.3856 -0.201382C81.3856 1.61184 82.7853 2.9718 84.6517 2.9718C86.5181 2.9718 87.9178 1.61184 87.9178 -0.201382C87.9178 -2.01461 86.5181 -3.37451 84.6517 -3.37451Z",
    fill: "url(#paint23_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.671 100.432C98.805 100.432 97.4052 101.792 97.4052 103.606C97.4052 105.419 98.805 106.779 100.671 106.779C102.538 106.779 103.938 105.419 103.938 103.606C103.938 101.792 102.538 100.432 100.671 100.432Z",
    fill: "url(#paint24_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.788 40.1429C201.921 40.1429 200.522 41.5028 200.522 43.316C200.522 45.1292 201.921 46.4891 203.788 46.4891C205.654 46.4891 207.054 45.1292 207.054 43.316C207.054 41.5028 205.654 40.1429 203.788 40.1429Z",
    fill: "url(#paint25_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.901 260.903C191.034 260.903 189.634 262.263 189.634 264.076C189.634 265.889 191.034 267.249 192.901 267.249C194.767 267.249 196.167 265.889 196.167 264.076C196.167 262.263 194.767 260.903 192.901 260.903Z",
    fill: "url(#paint26_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.437 225.545C168.949 225.545 166.927 227.509 166.927 229.927C166.927 232.344 168.949 234.309 171.437 234.309C173.926 234.309 175.948 232.344 175.948 229.927C175.948 227.509 173.926 225.545 171.437 225.545Z",
    fill: "url(#paint27_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.19 102.397C188.701 102.397 186.679 104.361 186.679 106.779C186.679 109.196 188.701 111.312 191.19 111.312C193.678 111.312 195.7 109.348 195.7 106.779C195.7 104.21 193.678 102.397 191.19 102.397Z",
    fill: "url(#paint28_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.034 14.4555C188.546 14.4555 186.524 16.4199 186.524 18.8375C186.524 21.2551 188.546 23.2195 191.034 23.2195C193.523 23.2195 195.545 21.2551 195.545 18.8375C195.545 16.4199 193.523 14.4555 191.034 14.4555Z",
    fill: "url(#paint29_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.067 272.538C127.578 272.538 125.556 274.502 125.556 276.92C125.556 279.337 127.578 281.301 130.067 281.301C132.555 281.301 134.577 279.337 134.577 276.92C134.577 274.502 132.555 272.538 130.067 272.538Z",
    fill: "url(#paint30_linear_48_3041)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.191 -38.1279V-6.69876L207.054 15.5132V38.0275L185.28 59.1817V132.164L202.855 149.087V173.264H204.099V148.634L186.524 131.56V59.635L208.143 38.6318V15.06L185.435 -7.15205V-38.1279H184.191Z",
    fill: "url(#paint31_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.327 129.293V178.854L177.348 187.467V223.278H178.436V187.014L169.571 178.25V129.746L200.21 99.9792L200.21 54.6487L221.518 33.9477V-21.0534L211.875 -30.2706V-39.3368H210.787V-29.6662L220.274 -20.449V33.4944L198.966 54.1954L198.966 99.5259L168.327 129.293Z",
    fill: "url(#paint32_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6276 25.7882V45.8848L117.935 66.5857L117.935 93.0286L178.125 151.505V172.961H179.37V151.052L119.179 92.5753L119.179 66.1324L97.7163 45.4314V25.7882H96.6276Z",
    fill: "url(#paint33_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35 0.856339V30.3212L175.481 42.1072V106.628L177.97 106.779V41.2006L165.683 29.2635V1.76298L181.236 -13.1961V-39.3368H178.747V-14.2538L163.35 0.856339Z",
    fill: "url(#paint34_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.109 52.231V98.9215H142.198V52.6843L157.129 38.1785V-12.4406L166.927 -21.809V-41.3011H165.683V-22.2622L156.04 -12.8939V37.7252L141.109 52.231Z",
    fill: "url(#paint35_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.868 18.9885V39.6895L164.439 83.9623V112.521L142.664 133.675V203.333L130.533 215.119V231.891H132.866V216.025L144.997 204.239V134.733L166.927 113.427V82.9046L121.357 38.7829V20.0462L131 10.5268V-40.8478H128.667V9.62019L118.868 18.9885Z",
    fill: "url(#paint36_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.623 45.7336L124.623 122.04L160.706 157.096V197.742H163.194V156.189L127.111 121.133L127.111 46.7913L143.909 30.3212V-39.3368H141.576V29.4146L124.623 45.7336Z",
    fill: "url(#paint37_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.224 206.053V231.891H117.469V206.506L135.199 189.28V139.568H134.11V188.827L116.224 206.053Z",
    fill: "url(#paint38_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2324 -22.5644L67.2324 66.2835L93.2059 91.3664L93.2059 136.848L111.558 154.527V172.508H112.647V154.074L94.4501 136.244L94.4501 90.9131L68.4766 65.8302L68.4766 -22.1111L84.8072 -37.9768V-43.5676H83.563V-38.4301L67.2324 -22.5644Z",
    fill: "url(#paint39_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3488 -7.90753L35.3488 67.039L43.2808 74.7452L43.2808 115.392L98.0274 168.579L98.0274 240.051L86.9847 250.779L87.7624 251.534L99.1161 240.655L99.1161 167.975L44.5251 114.938L44.5251 74.2919L36.593 66.5857L36.593 -7.30313L42.5032 -13.1961V-42.5099H41.4145V-13.6494L35.3488 -7.90753Z",
    fill: "url(#paint40_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0515 126.271V187.618H87.1402V126.724L110.314 104.21L110.314 23.6727L136.599 -1.86348V-41.3011H135.51V-2.4679L109.07 23.0683L109.07 103.757L86.0515 126.271Z",
    fill: "url(#paint41_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.321 170.997C201.921 170.997 200.988 172.055 200.988 173.264C200.988 174.472 202.077 175.53 203.321 175.53C204.565 175.53 205.654 174.472 205.654 173.264C205.654 172.055 204.565 170.997 203.321 170.997Z",
    fill: "url(#paint42_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.125 170.242C176.881 170.242 175.792 171.299 175.792 172.508C175.792 173.717 176.881 174.775 178.125 174.775C179.369 174.775 180.458 173.717 180.458 172.508C180.458 171.299 179.369 170.242 178.125 170.242Z",
    fill: "url(#paint43_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.847 229.171C115.602 229.171 114.514 230.229 114.514 231.438C114.514 232.647 115.602 233.704 116.847 233.704C118.246 233.704 119.179 232.647 119.179 231.438C119.179 230.229 118.091 229.171 116.847 229.171Z",
    fill: "url(#paint44_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.732 137.301C133.333 137.301 132.399 138.359 132.244 139.568C132.244 140.928 133.333 141.834 134.732 141.834C136.132 141.834 137.065 140.777 137.065 139.568C137.065 138.359 135.977 137.301 134.732 137.301Z",
    fill: "url(#paint45_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.336 169.788C110.936 169.788 110.003 170.846 110.003 172.055C110.003 173.264 111.092 174.321 112.336 174.321C113.736 174.321 114.669 173.264 114.669 172.055C114.669 170.846 113.58 169.788 112.336 169.788Z",
    fill: "url(#paint46_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0274 165.557C96.6276 165.557 95.6945 166.615 95.6945 167.824C95.6945 169.033 96.7832 170.242 98.0274 170.242C99.2716 170.242 100.36 169.184 100.36 167.824C100.36 166.464 99.2716 165.557 98.0274 165.557Z",
    fill: "url(#paint47_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.868 64.7725C117.469 64.7725 116.535 65.8302 116.535 67.039C116.535 68.2478 117.624 69.3055 118.868 69.3055C120.113 69.3055 121.201 68.2478 121.201 67.039C121.201 65.6791 120.113 64.6214 118.868 64.6214V64.7725Z",
    fill: "url(#paint48_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.129 35.7609C155.729 35.7609 154.796 36.8186 154.796 38.1785C154.796 39.5384 155.884 40.4451 157.129 40.4451C158.373 40.4451 159.462 39.3873 159.462 38.1785C159.462 36.9697 158.373 35.7609 157.129 35.7609Z",
    fill: "url(#paint49_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.902 129.595C184.502 129.595 183.569 130.653 183.569 131.862C183.569 133.071 184.658 134.128 185.902 134.279C187.146 134.279 188.235 133.222 188.235 131.862C188.235 130.502 187.146 129.595 185.902 129.595Z",
    fill: "url(#paint50_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.042 96.5039C140.798 96.5039 139.709 97.5616 139.709 98.7704C139.709 99.9792 140.798 101.037 142.042 101.037C143.442 101.037 144.375 99.9792 144.375 98.7704C144.375 97.5616 143.287 96.5039 142.042 96.5039Z",
    fill: "url(#paint51_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8281 88.6465C92.5838 88.6465 91.4951 89.7043 91.4951 90.9131C91.4951 92.1219 92.5838 93.1796 93.8281 93.1796C95.0723 93.1796 96.161 92.1219 96.161 90.9131C96.161 89.7043 95.0723 88.6465 93.8281 88.6465Z",
    fill: "url(#paint52_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4766 63.7148C67.0769 63.7148 65.9881 64.7725 66.1437 65.9813C66.1437 67.1901 67.2324 68.3989 68.4766 68.3989C69.7209 68.3989 70.8096 67.3412 70.8096 65.9813C70.8096 64.6214 69.7209 63.7148 68.4766 63.7148Z",
    fill: "url(#paint53_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1402 249.419C85.896 249.419 84.8073 250.477 84.8073 251.686C84.8073 252.894 85.896 253.952 87.1402 253.952C88.54 253.952 89.4731 252.894 89.4731 251.686C89.4731 250.477 88.3844 249.419 87.1402 249.419Z",
    fill: "url(#paint54_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8291 184.898C85.5849 184.898 84.4962 185.956 84.4962 187.165C84.4962 188.374 85.5849 189.432 86.8291 189.432C88.2289 189.432 89.1621 188.374 89.1621 187.165C89.1621 185.956 88.0734 184.898 86.8291 184.898Z",
    fill: "url(#paint55_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7163 25.0326C96.3165 25.0326 95.3833 26.0903 95.3833 27.2991C95.3833 28.5079 96.472 29.5657 97.7163 29.5657C98.9605 29.5657 100.049 28.5079 100.049 27.2991C100.049 26.0903 98.9605 25.0326 97.7163 25.0326Z",
    fill: "url(#paint56_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.692 101.641C108.448 101.641 107.359 102.699 107.359 103.908C107.359 105.117 108.448 106.326 109.848 106.326C111.247 106.326 112.181 105.268 112.181 104.059C112.181 102.85 111.092 101.792 109.848 101.792L109.692 101.641Z",
    fill: "url(#paint57_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.588 97.5616C198.344 97.5616 197.255 98.6194 197.255 99.8282C197.255 101.037 198.344 102.095 199.588 102.095C200.833 102.095 201.921 101.037 201.921 99.8282C201.921 98.6194 200.833 97.4105 199.588 97.4105V97.5616Z",
    fill: "url(#paint58_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.902 57.0663C184.502 57.0663 183.569 58.1241 183.569 59.3329C183.569 60.5417 184.658 61.5994 185.902 61.5994C187.146 61.5994 188.235 60.5417 188.235 59.3329C188.235 58.1241 187.146 57.0663 185.902 57.0663Z",
    fill: "url(#paint59_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.97 220.408C176.57 220.408 175.481 221.465 175.637 222.674C175.637 223.883 176.725 224.941 177.97 224.941C179.214 224.941 180.303 223.883 180.303 222.674C180.303 221.465 179.214 220.408 177.97 220.408Z",
    fill: "url(#paint60_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.95 194.267C160.084 194.267 158.529 195.778 158.529 197.591C158.529 199.404 160.084 200.915 161.95 200.915C163.817 200.915 165.372 199.404 165.372 197.591C165.372 195.778 163.817 194.267 161.95 194.267Z",
    fill: "url(#paint61_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57 103.152C174.704 103.152 173.148 104.663 173.148 106.477C173.148 108.29 174.704 109.801 176.57 109.801C178.436 109.801 179.836 108.29 179.836 106.477C179.836 104.663 178.281 103.152 176.414 103.152H176.57Z",
    fill: "url(#paint62_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.414 38.0274C174.548 38.0274 172.993 39.5384 172.993 41.3516C172.993 43.1649 174.548 44.6759 176.414 44.6759C178.281 44.6759 179.836 43.1649 179.836 41.3516C179.836 39.5384 178.281 38.0274 176.414 38.0274Z",
    fill: "url(#paint63_linear_48_3041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.466 228.869C129.6 228.869 128.045 230.38 128.045 232.193C128.045 234.007 129.6 235.518 131.466 235.518C133.333 235.518 134.888 234.007 134.888 232.193C134.888 230.38 133.333 228.869 131.466 228.869Z",
    fill: "url(#paint64_linear_48_3041)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M199.433 69.4566V85.9268H200.522V69.7589L214.83 56.3108V26.2415L220.74 20.4997V-5.64097L204.876 -21.0534L204.099 -20.2979L219.652 -5.18768V20.0463L213.742 25.7882V55.8575L199.433 69.4566Z",
    fill: "url(#paint65_linear_48_3041)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.97 -19.9957V7.50487L197.878 26.8459V46.6403L178.903 65.0747V128.689L194.3 143.648V164.651H195.234V143.194L179.992 128.235V65.3769L198.966 46.9425V26.5437L179.058 7.05159V-19.9957H177.97Z",
    fill: "url(#paint66_linear_48_3041)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.128 126.271V169.486L171.904 177.041V208.319H172.993V176.588L165.216 169.033V126.724L191.812 100.735L191.812 60.995L210.475 43.0138V-5.03661L202.232 -13.045V-21.0534H201.144V-12.5917L209.387 -4.58327V42.5605L190.879 60.6928L190.879 100.281L164.128 126.271Z",
    fill: "url(#paint67_linear_48_3041)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.449 35.7609V53.4399L120.113 71.5721L120.113 94.5396L172.682 145.612V164.349H173.615V145.159L121.201 94.0863L121.201 71.1188L102.538 52.9865V35.7609H101.449Z",
    fill: "url(#paint68_linear_48_3041)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.773 14.1533V39.8407L170.349 50.1156V106.477H172.526V49.209L161.795 38.9341V14.9088L175.326 1.76299L175.326 -21.0534H173.304L173.304 1.00749L159.773 14.1533Z",
    fill: "url(#paint69_linear_48_3041)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.331 58.8795V99.6771H141.265V59.3329L154.329 46.6403V2.51853L162.883 -5.64093L162.883 -22.7155H161.795L161.795 -6.09428L153.396 2.06524L153.24 46.187L140.331 58.8795Z",
    fill: "url(#paint70_linear_48_3041)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.046 30.019V48.0002L160.706 86.6822L160.706 111.614L141.731 130.049V190.791L131 201.066V215.723H133.177V201.973L143.753 191.698V130.955L162.883 112.37L162.883 85.7757L123.068 47.2447V30.7746L131.622 22.6151V-22.4133H129.444V21.7084L121.046 30.019Z",
    fill: "url(#paint71_linear_48_3041)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M126.023 53.2887L126.023 119.925L157.44 150.598V185.956H159.617V149.692L128.045 119.169L128.045 54.1954L142.82 39.8407V-21.0534H140.643V39.0852L126.023 53.2887Z",
    fill: "url(#paint72_linear_48_3041)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.713 193.209V215.723H119.802V193.662L135.199 178.552V135.337H134.11V178.099L118.713 193.209Z",
    fill: "url(#paint73_linear_48_3041)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.942 -6.39648L75.942 71.1188L98.4939 93.1797V132.768L114.513 148.332V164.047H115.602V147.879L99.5826 132.315V92.7264L76.8752 70.8166L76.8752 -5.94313L91.184 -19.8445V-24.6798H90.0953V-20.1467L75.942 -6.39648Z",
    fill: "url(#paint74_linear_48_3041)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9467 6.44717L47.9467 71.8743L54.9456 78.6739L54.9456 114.183L102.693 160.42L102.693 222.976L93.0504 232.345L93.8281 233.1L103.782 223.429L103.626 160.118L56.0343 113.73L56.0343 78.2206L49.0354 71.421L49.0354 6.90047L54.3235 1.91414V-23.7732H53.2347V1.46078L47.9467 6.44717Z",
    fill: "url(#paint75_linear_48_3041)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2727 123.551V177.192H93.2059V124.004L113.425 104.361V33.9477L136.443 11.7357V-22.7155H135.355V11.2824L112.492 33.6455V103.908L92.2727 123.551Z",
    fill: "url(#paint76_linear_48_3041)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200.055 83.8114C198.966 83.8114 198.033 84.718 198.033 85.7757C198.033 86.8334 198.966 87.74 200.055 87.74C201.144 87.74 202.077 86.8334 202.077 85.7757C202.077 84.718 201.144 83.8114 200.055 83.8114Z",
    fill: "url(#paint77_linear_48_3041)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M194.611 162.687C193.523 162.687 192.59 163.593 192.59 164.651C192.59 165.709 193.523 166.615 194.611 166.615C195.7 166.615 196.633 165.709 196.633 164.651C196.633 163.593 195.7 162.536 194.611 162.687Z",
    fill: "url(#paint78_linear_48_3041)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M172.682 161.931C171.593 161.931 170.66 162.838 170.66 163.895C170.66 164.953 171.593 165.86 172.682 165.86C173.77 165.86 174.704 164.953 174.704 163.895C174.704 162.838 173.77 161.931 172.682 161.931Z",
    fill: "url(#paint79_linear_48_3041)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.179 213.457C118.091 213.457 117.158 214.363 117.158 215.421C117.158 216.479 118.091 217.385 119.179 217.385C120.424 217.385 121.201 216.479 121.201 215.27C121.201 214.061 120.268 213.306 119.179 213.306V213.457Z",
    fill: "url(#paint80_linear_48_3041)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.732 133.222C133.488 133.222 132.555 134.128 132.71 135.186C132.71 136.244 133.644 137.15 134.732 137.15C135.821 137.15 136.754 136.244 136.754 135.186C136.754 134.128 135.821 133.222 134.732 133.222Z",
    fill: "url(#paint81_linear_48_3041)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.136 161.629C113.891 161.629 113.114 162.535 113.114 163.593C113.114 164.651 114.047 165.557 115.136 165.557C116.224 165.557 117.157 164.651 117.157 163.593C117.157 162.535 116.224 161.629 115.136 161.629Z",
    fill: "url(#paint82_linear_48_3041)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.693 158.002C101.604 158.002 100.671 158.909 100.671 159.967C100.671 161.024 101.604 161.931 102.693 161.931C103.782 161.931 104.715 161.024 104.715 159.967C104.715 158.909 103.782 158.002 102.693 158.002Z",
    fill: "url(#paint83_linear_48_3041)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120.89 69.91C119.802 69.91 118.868 70.8166 118.868 71.8743C118.868 72.932 119.802 73.8386 120.89 73.8386C122.134 73.8386 122.912 72.932 123.068 71.8743C123.068 70.6655 122.134 69.7589 120.89 69.7589V69.91Z",
    fill: "url(#paint84_linear_48_3041)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.329 44.5249C153.24 44.5249 152.307 45.4314 152.307 46.4892C152.307 47.5469 153.24 48.4535 154.329 48.4535C155.418 48.4535 156.351 47.5469 156.351 46.4892C156.351 45.4314 155.418 44.5249 154.329 44.5249Z",
    fill: "url(#paint85_linear_48_3041)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M179.525 126.422C178.281 126.422 177.503 127.329 177.503 128.386C177.503 129.444 178.436 130.351 179.525 130.351C180.614 130.351 181.547 129.444 181.547 128.386C181.547 127.329 180.614 126.271 179.525 126.271V126.422Z",
    fill: "url(#paint86_linear_48_3041)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M141.109 97.5617C140.02 97.5617 139.087 98.4683 139.087 99.526C139.087 100.584 140.02 101.49 141.109 101.49C142.198 101.49 143.131 100.584 143.131 99.526C143.131 98.4683 142.198 97.5617 141.109 97.5617Z",
    fill: "url(#paint87_linear_48_3041)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1161 90.762C98.0274 90.762 97.0942 91.6686 97.0942 92.7263C97.0942 93.784 98.0274 94.6907 99.1161 94.6907C100.205 94.6907 101.138 93.784 101.138 92.7263C101.138 91.5175 100.205 90.6109 99.1161 90.762Z",
    fill: "url(#paint88_linear_48_3041)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8753 69.0034C75.7866 69.0034 74.8534 69.91 74.8534 70.9677C74.8534 72.0254 75.7866 72.932 76.8753 72.932C77.964 72.932 78.8972 72.0254 78.8972 70.9677C78.8972 69.91 77.964 69.0034 76.8753 69.0034Z",
    fill: "url(#paint89_linear_48_3041)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2059 231.136C92.1172 231.136 91.184 232.042 91.184 233.1C91.184 234.158 92.1172 235.064 93.2059 235.064C94.2946 235.064 95.2278 234.158 95.2278 233.1C95.2278 232.042 94.2946 231.136 93.2059 231.136Z",
    fill: "url(#paint90_linear_48_3041)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8949 174.775C91.8062 174.775 90.873 175.681 90.873 176.739C90.873 177.797 91.8062 178.703 92.8949 178.703C93.9836 178.703 94.9167 177.797 94.9167 176.739C94.9167 175.681 93.9836 174.775 92.8949 174.775Z",
    fill: "url(#paint91_linear_48_3041)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.538 35.1565C101.449 35.1565 100.36 36.0632 100.516 37.1209C100.516 38.1786 101.449 39.0852 102.538 39.0852C103.626 39.0852 104.56 38.1786 104.56 37.1209C104.56 36.0632 103.626 35.1565 102.538 35.1565Z",
    fill: "url(#paint92_linear_48_3041)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M112.958 102.095C111.869 102.095 110.936 103.001 110.936 104.059C110.936 105.117 111.869 106.023 112.958 106.023C114.047 106.023 114.98 105.117 114.98 103.908C114.98 102.699 114.047 101.944 112.958 101.944V102.095Z",
    fill: "url(#paint93_linear_48_3041)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M191.345 98.4682C190.257 98.4682 189.323 99.3748 189.323 100.433C189.323 101.49 190.257 102.397 191.345 102.397C192.434 102.397 193.367 101.49 193.367 100.433C193.367 99.3748 192.434 98.4682 191.345 98.4682Z",
    fill: "url(#paint94_linear_48_3041)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M198.344 24.8815C197.255 24.8815 196.322 25.7882 196.322 26.997C196.322 28.2058 197.255 28.9613 198.344 28.9613C199.433 28.9613 200.366 28.0547 200.366 26.997C200.366 25.9393 199.433 25.0327 198.344 25.0327V24.8815Z",
    fill: "url(#paint95_linear_48_3041)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M179.525 63.2615C178.281 63.2615 177.503 64.1681 177.503 65.2258C177.503 66.2836 178.436 67.1902 179.525 67.1902C180.614 67.1902 181.547 66.2836 181.547 65.2258C181.547 64.1681 180.614 63.2615 179.525 63.2615Z",
    fill: "url(#paint96_linear_48_3041)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M172.526 205.751C171.437 205.751 170.504 206.657 170.504 207.715C170.504 208.773 171.437 209.679 172.526 209.679C173.615 209.679 174.548 208.773 174.548 207.715C174.548 206.657 173.615 205.751 172.526 205.751Z",
    fill: "url(#paint97_linear_48_3041)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M158.528 182.934C156.818 182.934 155.573 184.143 155.573 185.805C155.573 187.467 156.818 188.676 158.528 188.676C160.239 188.676 161.484 187.316 161.484 185.805C161.484 184.294 160.239 182.934 158.528 182.934Z",
    fill: "url(#paint98_linear_48_3041)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M171.282 103.455C169.571 103.455 168.327 104.663 168.327 106.325C168.327 107.988 169.571 109.196 171.282 109.196C172.993 109.196 174.237 107.988 174.237 106.325C174.237 104.663 172.993 103.455 171.282 103.455Z",
    fill: "url(#paint99_linear_48_3041)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M171.126 46.6403C169.571 46.6403 168.171 47.8491 168.171 49.5112C168.171 51.1734 169.571 52.3822 171.126 52.3822C172.682 52.3822 174.081 51.1734 174.081 49.5112C174.081 47.8491 172.682 46.6403 171.126 46.6403Z",
    fill: "url(#paint100_linear_48_3041)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M131.933 213.306C130.222 213.306 128.978 214.514 128.978 216.177C128.978 217.839 130.222 219.048 131.933 219.048C133.644 219.048 134.888 217.839 134.888 216.177C134.888 214.514 133.488 213.306 131.933 213.306Z",
    fill: "url(#paint101_linear_48_3041)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M195.389 85.6245C195.389 83.0557 197.567 80.7892 200.366 80.7892C203.166 80.7892 205.343 82.9046 205.343 85.6245C205.343 88.3443 203.166 90.4597 200.366 90.4597C197.567 90.4597 195.389 88.3443 195.389 85.6245ZM204.41 85.6245C204.41 83.509 202.543 81.6958 200.366 81.6958C198.189 81.6958 196.322 83.509 196.322 85.6245C196.322 87.7399 198.189 89.5531 200.366 89.5531C202.543 89.5531 204.41 87.7399 204.41 85.6245Z",
    fill: "url(#paint102_linear_48_3041)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M193.212 26.8459C193.212 24.2772 195.389 22.0106 198.189 22.0106C200.988 22.0106 203.166 24.1261 203.166 26.8459C203.166 29.5657 200.988 31.6812 198.189 31.6812C195.389 31.6812 193.212 29.5657 193.212 26.8459ZM202.232 26.8459C202.232 24.7305 200.366 22.9173 198.189 22.9173C196.011 22.9173 194.145 24.7305 194.145 26.8459C194.145 28.9613 196.011 30.7746 198.189 30.7746C200.366 30.7746 202.232 28.9613 202.232 26.8459Z",
    fill: "url(#paint103_linear_48_3041)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M190.101 164.5C190.101 161.931 192.278 159.665 195.078 159.665C197.878 159.665 200.055 161.78 200.055 164.5C200.055 167.22 197.878 169.335 195.078 169.335C192.278 169.335 190.101 167.22 190.101 164.5ZM199.122 164.5C199.122 162.233 197.255 160.571 195.078 160.571C192.901 160.571 191.034 162.384 191.034 164.5C191.034 166.615 192.901 168.428 195.078 168.428C197.255 168.428 199.122 166.615 199.122 164.5Z",
    fill: "url(#paint104_linear_48_3041)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7163 37.2719C97.7163 34.5521 99.8937 32.4366 102.693 32.4366C105.337 32.4366 107.67 34.5521 107.67 37.2719C107.67 39.9918 105.493 42.1072 102.693 42.1072C100.049 42.1072 97.7163 39.9918 97.7163 37.2719ZM106.737 37.2719C106.737 35.1565 104.871 33.3432 102.693 33.3432C100.516 33.3432 98.6494 35.1565 98.6494 37.2719C98.6494 39.3873 100.516 41.2005 102.693 41.2005C104.871 41.2005 106.737 39.3873 106.737 37.2719Z",
    fill: "url(#paint105_linear_48_3041)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7427 71.2698C71.7427 68.55 73.9202 66.4345 76.7197 66.4345C79.3637 66.4345 81.6967 68.55 81.6967 71.2698C81.6967 73.9897 79.5192 76.1051 76.7197 76.1051C73.9202 76.1051 71.7427 73.9897 71.7427 71.2698ZM80.7635 71.2698C80.7635 69.1544 78.8971 67.3412 76.7197 67.3412C74.5423 67.3412 72.6759 69.1544 72.6759 71.2698C72.6759 73.3853 74.5423 75.1985 76.7197 75.1985C78.8971 75.1985 80.7635 73.3853 80.7635 71.2698Z",
    fill: "url(#paint106_linear_48_3041)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M110.159 164.046C110.159 161.478 112.336 159.211 115.136 159.211C117.935 159.211 120.113 161.327 120.113 164.046C120.113 166.766 117.935 168.882 115.136 168.882C112.336 168.882 110.159 166.766 110.159 164.046ZM119.179 164.046C119.179 161.931 117.313 160.118 115.136 160.118C112.958 160.118 111.092 161.931 111.092 164.046C111.092 166.162 112.958 167.975 115.136 167.975C117.313 167.975 119.179 166.162 119.179 164.046Z",
    fill: "url(#paint107_linear_48_3041)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6955 233.402C88.6955 230.833 90.8729 228.567 93.6725 228.567C96.472 228.567 98.6494 230.682 98.6494 233.402C98.6494 236.122 96.472 238.237 93.6725 238.237C90.8729 238.237 88.6955 236.122 88.6955 233.402ZM97.7162 233.402C97.7162 231.136 95.8499 229.474 93.6725 229.474C91.495 229.474 89.6287 231.287 89.6287 233.402C89.6287 235.518 91.495 237.331 93.6725 237.331C95.8499 237.331 97.7162 235.518 97.7162 233.402Z",
    fill: "url(#paint108_linear_48_3041)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0734 177.192C88.0734 174.472 90.2509 172.357 93.0504 172.357C95.8499 172.357 98.0273 174.472 98.0273 177.192C98.0273 179.912 95.8499 182.028 93.0504 182.028C90.2509 182.028 88.0734 179.912 88.0734 177.192ZM97.0941 177.192C97.0941 175.077 95.2278 173.264 93.0504 173.264C90.873 173.264 89.0066 175.077 89.0066 177.192C89.0066 179.308 90.873 181.121 93.0504 181.121C95.2278 181.121 97.0941 179.308 97.0941 177.192Z",
    fill: "url(#paint109_linear_48_3041)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.825 215.27C114.825 213.004 116.691 211.19 119.024 211.19C121.357 211.19 123.223 213.004 123.223 215.27C123.223 217.537 121.357 219.35 119.024 219.35C116.691 219.35 114.825 217.537 114.825 215.27ZM122.446 215.27C122.446 213.457 120.89 211.946 119.024 211.946C117.157 211.946 115.602 213.457 115.602 215.27C115.602 217.083 117.157 218.594 119.024 218.594C120.89 218.594 122.446 217.083 122.446 215.27Z",
    fill: "url(#paint110_linear_48_3041)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M168.482 207.866C168.482 205.599 170.349 203.786 172.682 203.786C175.015 203.786 176.881 205.599 176.881 207.866C176.881 210.133 175.015 211.946 172.682 211.946C170.349 211.946 168.482 210.133 168.482 207.866ZM176.103 207.866C176.103 206.053 174.548 204.542 172.682 204.542C170.815 204.542 169.26 206.053 169.26 207.866C169.26 209.679 170.815 211.19 172.682 211.19C174.548 211.19 176.103 209.679 176.103 207.866Z",
    fill: "url(#paint111_linear_48_3041)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M168.638 164.198C168.638 161.931 170.504 160.118 172.837 160.118C175.17 160.118 177.036 161.931 177.036 164.198C177.036 166.464 175.17 168.277 172.837 168.277C170.504 168.277 168.638 166.464 168.638 164.198ZM176.259 164.198C176.259 162.384 174.704 160.873 172.837 160.873C170.971 160.873 169.416 162.384 169.416 164.198C169.416 166.011 170.971 167.522 172.837 167.522C174.704 167.522 176.259 166.011 176.259 164.198Z",
    fill: "url(#paint112_linear_48_3041)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.283 49.0579C164.283 45.4315 167.238 42.5605 170.971 42.5605C174.704 42.5605 177.659 45.4315 177.659 49.0579C177.659 52.6844 174.704 55.5553 170.971 55.5553C167.238 55.5553 164.283 52.6843 164.283 49.209V49.0579ZM176.414 49.0579C176.414 46.187 173.926 43.7693 170.971 43.7693C168.016 43.7693 165.527 46.187 165.527 49.0579C165.527 51.9288 168.016 54.3465 170.971 54.3465C174.081 54.3465 176.414 51.9288 176.414 49.0579Z",
    fill: "url(#paint113_linear_48_3041)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M164.283 106.174C164.283 102.548 167.238 99.677 170.971 99.677C174.704 99.677 177.659 102.548 177.659 106.174C177.659 109.801 174.704 112.672 170.971 112.672C167.238 112.672 164.283 109.801 164.283 106.326V106.174ZM176.414 106.174C176.414 103.303 173.926 100.886 170.971 100.886C168.016 100.886 165.527 103.303 165.527 106.174C165.527 109.045 168.016 111.463 170.971 111.463C173.926 111.463 176.414 109.045 176.414 106.174Z",
    fill: "url(#paint114_linear_48_3041)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M151.996 185.956C151.996 182.481 154.951 179.459 158.684 179.459C162.417 179.459 165.372 182.33 165.372 185.956C165.372 189.583 162.417 192.454 158.684 192.302C155.107 192.302 151.996 189.431 151.996 185.956ZM164.128 185.956C164.128 183.085 161.639 180.668 158.684 180.668C155.729 180.668 153.24 183.085 153.24 185.956C153.24 188.827 155.729 191.245 158.684 191.245C161.639 191.245 164.128 188.827 164.128 185.956Z",
    fill: "url(#paint115_linear_48_3041)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M124.934 215.874C124.934 212.399 127.889 209.377 131.622 209.377C135.354 209.377 138.31 212.248 138.31 215.723C138.31 219.199 135.354 222.221 131.622 222.221C127.889 222.221 124.934 219.35 124.934 215.723V215.874ZM137.065 215.874C137.065 213.004 134.577 210.586 131.622 210.586C128.667 210.586 126.178 213.004 126.178 215.874C126.178 218.745 128.667 221.163 131.622 221.163C134.577 221.163 137.065 218.745 137.065 215.874Z",
    fill: "url(#paint116_linear_48_3041)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_48_3041",
    x1: 215.919,
    y1: 294.598,
    x2: 215.919,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_48_3041",
    x1: 138.932,
    y1: 294.599,
    x2: 138.932,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_48_3041",
    x1: 185.28,
    y1: 294.598,
    x2: 185.28,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_48_3041",
    x1: 160.55,
    y1: 294.598,
    x2: 160.55,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_48_3041",
    x1: 145.62,
    y1: 294.598,
    x2: 145.62,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_48_3041",
    x1: 147.019,
    y1: 294.598,
    x2: 147.019,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_48_3041",
    x1: 122.446,
    y1: 294.598,
    x2: 122.446,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_48_3041",
    x1: 74.0757,
    y1: 294.598,
    x2: 74.0757,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_48_3041",
    x1: 43.2807,
    y1: 294.598,
    x2: 43.2807,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_48_3041",
    x1: 102.849,
    y1: 294.598,
    x2: 102.849,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_48_3041",
    x1: 193.212,
    y1: 294.599,
    x2: 193.212,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_48_3041",
    x1: 110.47,
    y1: 294.599,
    x2: 110.47,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_48_3041",
    x1: 134.421,
    y1: 294.598,
    x2: 134.421,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_48_3041",
    x1: 104.249,
    y1: 294.598,
    x2: 104.249,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_48_3041",
    x1: 84.8072,
    y1: 294.599,
    x2: 84.8072,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_48_3041",
    x1: 113.114,
    y1: 294.751,
    x2: 113.114,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_48_3041",
    x1: 164.905,
    y1: 294.597,
    x2: 164.905,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_48_3041",
    x1: 203.788,
    y1: 294.598,
    x2: 203.788,
    y2: -105.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_48_3041",
    x1: 144.375,
    y1: 294.598,
    x2: 144.375,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_48_3041",
    x1: 79.3637,
    y1: 294.598,
    x2: 79.3637,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_48_3041",
    x1: 44.9916,
    y1: 294.597,
    x2: 44.9916,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_48_3041",
    x1: 70.343,
    y1: 294.598,
    x2: 70.343,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_48_3041",
    x1: 69.7209,
    y1: 294.599,
    x2: 69.7209,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_48_3041",
    x1: 84.6517,
    y1: 294.6,
    x2: 84.6517,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_48_3041",
    x1: 100.671,
    y1: 294.599,
    x2: 100.671,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_48_3041",
    x1: 203.788,
    y1: 294.597,
    x2: 203.788,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_48_3041",
    x1: 192.901,
    y1: 294.598,
    x2: 192.901,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_48_3041",
    x1: 171.438,
    y1: 294.598,
    x2: 171.438,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_48_3041",
    x1: 191.19,
    y1: 294.598,
    x2: 191.19,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_48_3041",
    x1: 191.034,
    y1: 294.599,
    x2: 191.034,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_48_3041",
    x1: 130.222,
    y1: 294.598,
    x2: 130.222,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_48_3041",
    x1: 196.167,
    y1: 294.599,
    x2: 196.167,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_48_3041",
    x1: 194.922,
    y1: 294.598,
    x2: 194.922,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_48_3041",
    x1: 137.999,
    y1: 294.599,
    x2: 137.999,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_48_3041",
    x1: 172.215,
    y1: 294.599,
    x2: 172.215,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_48_3041",
    x1: 154.018,
    y1: 294.598,
    x2: 154.018,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_48_3041",
    x1: 142.82,
    y1: 294.598,
    x2: 142.82,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_48_3041",
    x1: 143.909,
    y1: 294.598,
    x2: 143.909,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_48_3041",
    x1: 125.712,
    y1: 294.598,
    x2: 125.712,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_48_3041",
    x1: 89.9397,
    y1: 294.598,
    x2: 89.9397,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_48_3041",
    x1: 67.2325,
    y1: 294.598,
    x2: 67.2325,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_48_3041",
    x1: 111.247,
    y1: 294.598,
    x2: 111.247,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_48_3041",
    x1: 203.166,
    y1: 294.598,
    x2: 203.166,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_48_3041",
    x1: 178.125,
    y1: 294.598,
    x2: 178.125,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_48_3041",
    x1: 116.847,
    y1: 294.598,
    x2: 116.847,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_48_3041",
    x1: 134.577,
    y1: 294.598,
    x2: 134.577,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_48_3041",
    x1: 112.336,
    y1: 294.6,
    x2: 112.336,
    y2: -105.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_48_3041",
    x1: 98.0274,
    y1: 294.599,
    x2: 98.0274,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_48_3041",
    x1: 118.868,
    y1: 294.599,
    x2: 118.868,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_48_3041",
    x1: 157.129,
    y1: 294.6,
    x2: 157.129,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_48_3041",
    x1: 185.902,
    y1: 294.75,
    x2: 185.902,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_48_3041",
    x1: 142.042,
    y1: 294.598,
    x2: 142.042,
    y2: -105.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_48_3041",
    x1: 93.8281,
    y1: 294.598,
    x2: 93.8281,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_48_3041",
    x1: 68.4766,
    y1: 294.597,
    x2: 68.4766,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_48_3041",
    x1: 87.1402,
    y1: 294.598,
    x2: 87.1402,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_48_3041",
    x1: 86.8292,
    y1: 294.6,
    x2: 86.8292,
    y2: -105.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_48_3041",
    x1: 97.7163,
    y1: 294.598,
    x2: 97.7163,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_48_3041",
    x1: 109.692,
    y1: 294.599,
    x2: 109.692,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_48_3041",
    x1: 199.588,
    y1: 294.597,
    x2: 199.588,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_48_3041",
    x1: 185.902,
    y1: 294.749,
    x2: 185.902,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_48_3041",
    x1: 177.97,
    y1: 294.598,
    x2: 177.97,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_48_3041",
    x1: 161.95,
    y1: 294.598,
    x2: 161.95,
    y2: -105.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_48_3041",
    x1: 176.57,
    y1: 294.599,
    x2: 176.57,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_48_3041",
    x1: 176.414,
    y1: 294.598,
    x2: 176.414,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_48_3041",
    x1: 131.466,
    y1: 294.599,
    x2: 131.466,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_48_3041",
    x1: 210.164,
    y1: 294.598,
    x2: 210.164,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_48_3041",
    x1: 188.39,
    y1: 294.598,
    x2: 188.39,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_48_3041",
    x1: 187.301,
    y1: 294.599,
    x2: 187.301,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_48_3041",
    x1: 137.532,
    y1: 294.599,
    x2: 137.532,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_48_3041",
    x1: 167.549,
    y1: 294.598,
    x2: 167.549,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_48_3041",
    x1: 151.53,
    y1: 294.598,
    x2: 151.53,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_48_3041",
    x1: 141.887,
    y1: 294.598,
    x2: 141.887,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_48_3041",
    x1: 142.82,
    y1: 294.598,
    x2: 142.82,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_48_3041",
    x1: 126.956,
    y1: 294.598,
    x2: 126.956,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_48_3041",
    x1: 95.6943,
    y1: 294.599,
    x2: 95.6943,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_48_3041",
    x1: 75.7866,
    y1: 294.599,
    x2: 75.7866,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_48_3041",
    x1: 114.358,
    y1: 294.598,
    x2: 114.358,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_48_3041",
    x1: 200.055,
    y1: 294.597,
    x2: 200.055,
    y2: -105.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_48_3041",
    x1: 194.611,
    y1: 294.598,
    x2: 194.611,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_48_3041",
    x1: 172.682,
    y1: 294.598,
    x2: 172.682,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_48_3041",
    x1: 119.179,
    y1: 294.599,
    x2: 119.179,
    y2: -105.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_48_3041",
    x1: 134.732,
    y1: 294.749,
    x2: 134.732,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_48_3041",
    x1: 115.136,
    y1: 294.598,
    x2: 115.136,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_48_3041",
    x1: 102.693,
    y1: 294.6,
    x2: 102.693,
    y2: -105.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_48_3041",
    x1: 120.89,
    y1: 294.599,
    x2: 120.89,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_48_3041",
    x1: 154.329,
    y1: 294.748,
    x2: 154.329,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_48_3041",
    x1: 179.369,
    y1: 294.599,
    x2: 179.369,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_48_3041",
    x1: 141.109,
    y1: 294.6,
    x2: 141.109,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_48_3041",
    x1: 99.1161,
    y1: 294.6,
    x2: 99.1161,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_48_3041",
    x1: 76.8753,
    y1: 294.748,
    x2: 76.8753,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_48_3041",
    x1: 93.2059,
    y1: 294.599,
    x2: 93.2059,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_48_3041",
    x1: 92.8949,
    y1: 294.598,
    x2: 92.8949,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_48_3041",
    x1: 102.538,
    y1: 294.601,
    x2: 102.538,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_48_3041",
    x1: 112.958,
    y1: 294.599,
    x2: 112.958,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_48_3041",
    x1: 191.345,
    y1: 294.597,
    x2: 191.345,
    y2: -105.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_48_3041",
    x1: 198.344,
    y1: 294.599,
    x2: 198.344,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_48_3041",
    x1: 179.369,
    y1: 294.6,
    x2: 179.369,
    y2: -105.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_48_3041",
    x1: 172.526,
    y1: 294.599,
    x2: 172.526,
    y2: -105.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_48_3041",
    x1: 158.528,
    y1: 294.598,
    x2: 158.528,
    y2: -105.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_48_3041",
    x1: 171.282,
    y1: 294.599,
    x2: 171.282,
    y2: -105.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_48_3041",
    x1: 171.282,
    y1: 294.599,
    x2: 171.282,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_48_3041",
    x1: 131.933,
    y1: 294.599,
    x2: 131.933,
    y2: -105.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_48_3041",
    x1: 200.366,
    y1: 294.598,
    x2: 200.366,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_48_3041",
    x1: 198.189,
    y1: 294.598,
    x2: 198.189,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_48_3041",
    x1: 195.078,
    y1: 294.598,
    x2: 195.078,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_48_3041",
    x1: 102.693,
    y1: 294.6,
    x2: 102.693,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_48_3041",
    x1: 76.7197,
    y1: 294.6,
    x2: 76.7197,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_48_3041",
    x1: 115.136,
    y1: 294.598,
    x2: 115.136,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_48_3041",
    x1: 93.6725,
    y1: 294.598,
    x2: 93.6725,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_48_3041",
    x1: 92.8948,
    y1: 294.598,
    x2: 92.8948,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_48_3041",
    x1: 119.024,
    y1: 294.599,
    x2: 119.024,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_48_3041",
    x1: 172.682,
    y1: 294.599,
    x2: 172.682,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_48_3041",
    x1: 172.837,
    y1: 294.599,
    x2: 172.837,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_48_3041",
    x1: 170.971,
    y1: 294.599,
    x2: 170.971,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_48_3041",
    x1: 170.971,
    y1: 294.599,
    x2: 170.971,
    y2: -105.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_48_3041",
    x1: 158.529,
    y1: 294.598,
    x2: 158.529,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_48_3041",
    x1: 131.622,
    y1: 294.598,
    x2: 131.622,
    y2: -105.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignAbout);
export default __webpack_public_path__ + "static/media/design-about.4d669027cb8892361adbd08e92b5cc22.svg";
export { ForwardRef as ReactComponent };